import { render, staticRenderFns } from "./columndetail.vue?vue&type=template&id=ac414ea8&"
import script from "./columndetail.vue?vue&type=script&lang=js&"
export * from "./columndetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports